export default __webpack_public_path__ + "static/media/TermsOfService.ko.d84f8561.md";